import PropTypes from 'prop-types';
import React from 'react';

function DealSideRow({ label, value }) {
  return (
    <div className="deal-side-row">
      <span className="deal-side-row-label">{label}</span>
      <span className="deal-side-row-value">{value || '—'}</span>
    </div>
  );
}

DealSideRow.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node,
};

export default DealSideRow;
